import React, { Component } from 'react';
import { observer } from 'mobx-react';
import dshStore from '../request/model';
import { getMap } from '../request/dao';
import Iconc from 'components/Iconc';
import styleJson from 'common/config/map/bmap_config.json';
// import kmlData from 'common/config/map/roadBmap.json';
import parseKml from 'common/js/parseKml';
import RealTime from './RealTime';
import ScrollText from './ScrollText';
import './index.styl';

const BMap = window.BMap;
const clzpre = 'dsh-map';
const center = [116.13657757000628, 39.03500143875472];

const locationIcon = require('common/images/map-location.svg');
const cameraError = require('common/images/camera1.png');
const cameraWarn = require('common/images/camera2.png');
const cameraNormal = require('common/images/camera3.png');
const kmlSign = require('common/images/kmlsign.svg');

@observer
class Map extends Component {
    constructor(props) {
        super(props);
        getMap();
    }

    componentDidMount() {
        this.initMap();
    }

    initMap = () => {
        const map = new BMap.Map('map');
        // 创建地图实例
        const point = new BMap.Point(...center);
        // 创建点坐标
        map.centerAndZoom(point, 15);
        map.setMapStyleV2({ styleJson });
        // map.enableScrollWheelZoom();
        const opts = {
            position: point, // 指定文本标注所在的地理位置
            offset: new BMap.Size(15, -20) //设置文本偏移量
        };
        const label = new BMap.Label('项目位置', opts); // 创建文本标注对象
        label.setStyle({
            color: '#EAA80D',
            fontSize: '16px',
            height: '20px',
            lineHeight: '20px',
            fontFamily: '微软雅黑',
            border: 'none',
            backgroundColor: 'transparent'
        });
        map.addOverlay(label);
        const myIcon = new BMap.Icon(locationIcon, new BMap.Size(18, 36), {
            imageSize: new BMap.Size(18, 18),
            imageOffset: new BMap.Size(0, 0)
        });
        const marker2 = new BMap.Marker(point, { icon: myIcon }); // 创建标注
        map.addOverlay(marker2);
        this.map = map;
        parseKml().then(res => this.addKml(res));
    };

    addKml = kmlData => {
        const that = this;
        const canvasLayer = new BMap.CanvasLayer({
            update: update
        });

        function update() {
            const ctx = this.canvas.getContext('2d');
            if (!ctx) {
                return;
            }
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            kmlData.forEach(item => {
                const { geometry, style, name } = item;
                geometry.forEach(geo => {
                    switch (geo.type) {
                        case 'LineString':
                            that.drawLineString(geo, style, ctx);
                            break;
                        case 'Point':
                            that.drawPoint(geo, name);
                            break;
                        default:
                    }
                });
            });
        }
        this.map.addOverlay(canvasLayer);
    };

    drawLineString = (item, style, ctx) => {
        ctx.beginPath();
        const { LineStyle } = style;
        ctx.strokeStyle = `#${LineStyle.color}`;
        let w = parseInt(LineStyle.width);
        if (!ctx.lineWidth || ctx.lineWidth <= 1) {
            w = 2;
        }
        ctx.lineWidth = w;

        const coordinates = this.getCoordinates(item);
        coordinates.forEach((par, ind) => {
            const pixel = this.map.pointToPixel(new BMap.Point(par[0], par[1]));
            if (ind === 0) {
                ctx.moveTo(pixel.x, pixel.y);
            } else {
                ctx.lineTo(pixel.x, pixel.y);
            }
        });
        ctx.closePath();
        ctx.stroke();
    };

    drawPoint(item, name) {
        const parentSize = new BMap.Size(18, 36);
        const imgSize = new BMap.Size(18, 18);
        const offset = new BMap.Size(0, 0);
        const coordinates = this.getCoordinates(item);
        const point = new BMap.Point(coordinates[0][0], coordinates[0][1]);
        const myIcon = new BMap.Icon(kmlSign, parentSize, {
            imageSize: imgSize,
            imageOffset: offset
        });
        const marker = new BMap.Marker(point, { icon: myIcon }); // 创建标注
        marker.setTitle(name);
        marker.setZIndex(100);
        this.map.addOverlay(marker);
    }

    getCoordinates = obj => {
        if (obj.coordinates) {
            return obj.coordinates;
        } else {
            let res = null;
            for (let key in obj) {
                if (typeof obj[key] === 'object') {
                    res = this.getCoordinates(obj[key]);
                    if (res) {
                        return res;
                    }
                }
            }
        }
    };

    getLinesSeries = (data, opacity, width) => {
        return {
            type: 'lines3D',
            coordinateSystem: 'geo3D',
            polyline: true,
            data,
            silent: true,
            lineStyle: {
                normal: {
                    color: '#2787c5',
                    opacity,
                    width
                }
            },
            progressiveThreshold: 500,
            progressive: 200
        };
    };

    getWeatherDom = status => {
        let str = '晴天';
        let type = 'fine_icon';
        switch (status) {
            case 4:
                str = '雪天';
                type = 'xue';
                break;
            case 3:
                str = '暴雨';
                type = 'baoyu';
                break;
            case 2:
                str = '雨天';
                type = 'tianqi-xiaoyu';
                break;
            case 1:
                str = '阴天';
                type = 'tianqi-yin';
                break;
            case 0:
            default:
        }
        return (
            <span>
                <Iconc type={type} className="weather" />
                {str}
            </span>
        );
    };

    setCamera = marks => {
        // WGS84
        // marks = [
        // [116.1180722, 39.015775],
        //   [116.1174556, 39.01385556],
        //   [116.1174556, 39.01385556],
        //   [116.1183167, 39.02048611],
        //   [116.1185306, 39.02074444],
        //   [116.1244194, 39.02780556]
        //   [116.1244194, 39.02780556],
        //   [116.1257861, 39.03115],
        //   [116.1257861, 39.03115],
        //   [116.1274194, 39.03331389],
        //   [116.1274194, 39.03331389]
        //   [116.1339722, 39.04280556],
        //   [116.1339722, 39.04280556],
        //   [116.1356722, 39.04532222],
        //   [116.125794444, 39.03113055]
        // ];
        // marks.forEach(mark => {
        //   let p = new BMap.Point(mark[0], mark[1]);
        //   var points = [p];
        //   var converter = new BMap.Convertor();
        //   var translateCallback = function(data) {
        //     console.log('xxxxxxxxxxxxxxxxxx');
        //     console.log(data);
        //     if (data.status === 0) {
        //       for (var i = 0; i < data.points.length; i++) console.log(data.points[i]);
        //     }
        //   };

        //   converter.translate(points, 3, 5, translateCallback);
        // });
        marks = [
            [116.13082006331588, 39.022755545214295],
            [116.13020631903035, 39.020824404337965],
            [116.13020631903035, 39.020824404337965],
            [116.13712418808585, 39.034903101389645],
            [116.13106554390967, 39.02747446558916],
            [116.13127815214588, 39.02773649379767],
            [116.13712418808585, 39.034903101389645],
            [116.13848049019286, 39.03827317194678],
            [116.14010081859773, 39.04046582540164],
            [116.13848049019286, 39.03827317194678],
            [116.14010081859773, 39.04046582540164],
            [116.14660022786737, 39.050064999056424],
            [116.14660022786737, 39.050064999056424],
            [116.14828595693469, 39.05260608785116],
            [116.1384888504553, 39.038253794032286]
        ];

        if (this.map && this.map.addOverlay && marks && marks.length) {
            const parentSize = new BMap.Size(25, 76);
            const imgSize = new BMap.Size(25, 38);
            const offset = new BMap.Size(0, 5);
            marks.forEach(mark => {
                //const p = JSON.parse(mark.point).reverse();
                const p = mark;
                const point = new BMap.Point(...p);
                // const point = new BMap.Point(...center);
                let iconUrl;
                switch (mark.status) {
                    case 0:
                        iconUrl = cameraError;
                        break;
                    case 1:
                        iconUrl = cameraWarn;
                        break;
                    case 2:
                    default:
                        iconUrl = cameraNormal;
                }
                const myIcon = new BMap.Icon(iconUrl, parentSize, {
                    imageSize: imgSize,
                    imageOffset: offset
                });
                const marker2 = new BMap.Marker(point, { icon: myIcon }); // 创建标注
                this.map.addOverlay(marker2);
            });
        }
    };

    render() {
        const { mapdata } = this.props.dshStore;
        const url = require('../../../common/images/projectShow.jpg');
        this.setCamera(mapdata.marks);
        return (
            <div className={clzpre}>
                <p className={`${clzpre}-info`}>
                    <span>{mapdata.companyName}</span>
                    <span>
                        <Iconc type="zhiyuandidian1" className="location" />
                        {mapdata.locationName}
                    </span>
                    <span>
                        <Iconc type="Group-" className="time" />
                        <RealTime />
                    </span>
                    {this.getWeatherDom(mapdata.weatherStatus)}
                </p>
                <ScrollText className={`${clzpre}-text text1`}>
                    <p>一、工程概况</p>
                    <p>1.工程简介</p>
                    <p>
                        西侧干路项目全长约6.6km，红线宽45（44）m，道路等级为城市主干路，双向6车道，设计速度60km/h。共分为两段，第一段设计起点与起步区东西轴线东延相交，向北依次下穿规划轨道快线廊道，在建京雄城际动车所，规划的雄忻城际铁路，与现况保静公路平交后，跨越新盖房分洪道，与昝岗片区多条内部道路相交，设计终点与K1线相交，路线长度约4.6km。第二段设计起点与昝岗片区E1线相交，路线向北，与昝岗片区多条内部道路相交，设计终点与现况荣乌高速相交，路线长约2km。项目设置新盖房分洪道特大桥1座，下穿京雄高铁分离式立交1座，新建改移马庄干渠跨河桥1座，新建荣乌高速互通式立交1座，1#雨水泵站1座，改移干渠1条。
                    </p>
                    <p>
                        （1）西侧干路与京雄铁路相交处设置分离式立交一座，西侧干路下穿京雄铁路，采用单箱四室闭合框架结构，闭合框架长27m，两侧设置U型槽，南北两侧分别长132m和116m。
                    </p>
                    <p>
                        （2）
                        跨越新盖房分洪道特大桥，全桥长2223m，宽40m，全桥采用两种结构形式，标准跨采用40m预制小箱梁，跨越大堤处，采用变截面连梁，最大跨径95m，荷载等级采用城-A级，跨大堤净空4.5m。
                    </p>
                    <p>（3）荣乌互通式立交，在荣乌快速路设置半菱形互通式立交，匝道宽9m。</p>
                    <p>主要实施内容包括道路工程、交通工程、桥梁工程、排水工程、景观绿化工程、照明工程、监控工程。</p>
                </ScrollText>
                <ScrollText className={`${clzpre}-text text2`}>
                    <img src={url} />
                </ScrollText>
                <div className={`${clzpre}-dom`} id="map"></div>
            </div>
        );
    }
}

export default props => <Map {...props} dshStore={dshStore} />;
